import React, { useContext, useEffect, useState } from 'react';
import AutocompleteSearch from '../UI/AutocompleteSearch';
import { InventoriesContext } from '../../contexts/InventoriesContext';
import { Bold } from '../UI/TextFormatters';

const SupplierFilter = ({ value, setValue, narrow }) => {
  const { getTheSuppliers } = useContext(InventoriesContext);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    getTheSuppliers().then(res => setOptions(res));
  }, []);

  return (
    <div style={{ width: narrow ? 220 : 300 }}>
      <AutocompleteSearch
        value={value}
        setValue={setValue}
        options={options}
        optionsDisplay={option => `${option.cuit} - ${option.businessName}`}
        label="Proveedor"
        renderOption={option => (
          <div>
            {option.cuit} - <Bold>{option.businessName}</Bold>
          </div>
        )}
      />
    </div>
  );
};

export default SupplierFilter;
